export default __webpack_public_path__ + "static/media/science-card-bg.cad76f7a.svg";